{
  "pt": {
    "integration_error": {
      "customer": {
        "first_name": {
          "blank": "O nome próprio não pode estar em branco."
        },
        "last_name": {
          "blank": "O apelido não pode estar em branco."
        },
        "phone": {
          "blank": "O número de telefone não pode estar em branco."
        },
        "user": {
          "taken": "O endereço de correio eletrónico deve ser único."
        }
      }
    }
  }
}